﻿

(() => {

    angular.module('fliptoWeb')
        .controller('BlogCtrl', ['$http', '$sce', '$window', '$location', '$analytics', '$stateParams',
            function ($http, $sce, $window, $location, $analytics, $stateParams) {
            var vm = this;
            var catSlug = $stateParams.categorySlug;
            var isResetCache = !!($location.search().reset);
            var qs = isResetCache ? '?reset=true' : '';

            vm.currentPageNumber = 1;
            vm.hasNextPage = true;
            vm.blogPosts = [];
            vm.trust = $sce.trustAsHtml;
            vm.isLoading = false;
            vm.isSubscribed = false;
            vm.isSubscribeError = false;

            vm.getStyle = article => {
                var style = {};
                if (article.FeaturedImageUrl)
                    style["background-image"] = "url(" + article.FeaturedImageUrl + ")";
                return style;
            }

            vm.getNextPage = () => {
                //[HttpGet, Route("blog/api/getPage/{pageNumber}"), Route("blog/api/getPage/{categorySlug}/{pageNumber}")]
                vm.isLoading = true;

                if (vm.hasNextPage) {
                    $http
                        .get('/api/blog/getPage/' + (catSlug ? 'cat/' + catSlug + "/" : "") + (vm.currentPageNumber + 1) + window.location.search)
                        .then((response) => {
                        //console.log(response);
                        response = response.data.Data;

                        if (!response) {
                            //handle error
                            return;
                        }

                        //increment page number
                        vm.currentPageNumber++;

                        //determine if response had any posts;
                        if (!response.Posts || response.Posts.length < 1) {
                            //no data returned, probably end of records
                            vm.hasNextPage = false;
                            return;
                        }
                        //determine if has next page
                        if (vm.currentPageNumber * $window.BLOG_POST_LIST_PAGE_SIZE >= response.TotalCount)
                            vm.hasNextPage = false;

                        angular.forEach(response.Posts,(post) => {
                            vm.blogPosts.push(post);
                        });
                    })
                        .finally(() => {
                        vm.isLoading = false;
                    });
                }
            }

            vm.subscribe = function (email) {
                $analytics.setUsername(email);
                $http.post("/api/subscriptions/add-blog-subscription", { Email: email })
                    .then(response => {
                        vm.isSubscribed = true;
                        vm.isSubscribeError = false;
                    }, error => {
                        vm.isSubscribed = false;
                        vm.isSubscribeError = true;
                    });
            };

            return vm;
        }]);
})()
